"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const elements_ui_utils_1 = require("@hydrogen/elements.ui.utils");
const ProfileSeparator = (props) => {
    const TagName = props.as || 'div';
    const baseClasses = 'border-t border-content-separator w-full';
    const marginClass = props.margin ? props.margin : 'my-3';
    return (react_1.default.createElement(react_1.default.Fragment, null, props.as
        ? react_1.default.createElement("hr", { className: (0, elements_ui_utils_1.classNames)(baseClasses, marginClass, props.className) })
        : react_1.default.createElement(TagName, { className: (0, elements_ui_utils_1.classNames)(baseClasses, marginClass, props.className), role: "separator" })));
};
exports.default = ProfileSeparator;
//# sourceMappingURL=ProfileSeparator.js.map